import React, { useEffect, useState } from "react";
import { ProjectSearchFormProps } from "../../../../interfaces/projects";
import { SearchPropertiesService } from "../../../../services/search-properties";
import "./projectSearchForm.scss";

const ProjectSearchForm: React.FC<ProjectSearchFormProps> = ({
  searchForm,
  colors,
  properties,
  allProperties,
  onSearch,
}) => {
  const [ambientes, setAmbientes] = useState<string>("");
  const [orientacion, setOrientacion] = useState<string>("");
  const [exterior, setExterior] = useState<string>("");
  const [filteredBy, setFilteredBy] = useState("");

  const [canDisplayFilters, setCanDisplayFilters] = useState<boolean>(true);

  const [ambientesOptions, setAmbientesOptions] = useState<any>([]);
  const [orientacionOptions, setOrientacionOptions] = useState<any>([]);
  const [exteriorOptions, setExteriorOptions] = useState<any>([]);

  useEffect(() => {
    if (ambientes || orientacion || exterior) {
      onSearch({ ambientes, orientacion, exterior });

      if (ambientes !== "") {
        setFilteredBy("Ambientes");
      }
      if (orientacion !== "") {
        setFilteredBy("Orientacion");
      }
      if (exterior !== "") {
        setFilteredBy("Exterior");
      }
    }
  }, [ambientes, orientacion, exterior]);

  // set options to render
  useEffect(() => {
    const { ambientes, orientacion, exterior } = searchForm;
    setAmbientesOptions(ambientes);
    // setOrientacionOptions(orientacion);
    // setExteriorOptions(exterior);

    getOrientacionOptions(orientacion);
    getExteriorOptions(exterior);
  }, [searchForm, properties]);

  const getOrientacionOptions = (orientacion) => {
    setOrientacionOptions({
      title: orientacion.title,
      options: SearchPropertiesService.getFilteredOptions(
        orientacion.options,
        allProperties,
        ambientes,
        "orientacion"
      ),
    });
  };

  const getExteriorOptions = (exterior) => {
    setExteriorOptions({
      title: exterior.title,
      options: SearchPropertiesService.getFilteredOptions(
        exterior.options,
        allProperties,
        ambientes,
        "exterior"
      ),
    });
  };

  useEffect(() => {
    if (ambientes && !orientacion && !exterior && properties) {
      // se muestran el resto de los filtros si tienen mas de una orientación
      setCanDisplayFilters(
        [...new Set(properties.map(({ orientacion }) => orientacion))].length >
          1
      );
    }
  }, [ambientes, properties]);

  return (
    <>
      <div className="project-search-form">
        {ambientesOptions?.options && (
          <select
            style={{
              backgroundImage: "url(../down-project.svg)",
              color: colors.primary,
            }}
            onChange={({ target: { value } }) => {
              setAmbientes(value);
              setExterior("");
              setOrientacion("");
            }}
            value={ambientes}
            defaultValue=""
            required
          >
            <option disabled value="">
              {ambientesOptions?.title}
            </option>

            {ambientesOptions?.options.map((option, i) => (
              <option value={option.value} key={i}>
                {option.label}
              </option>
            ))}
          </select>
        )}

        {orientacionOptions?.options && (
          <select
            style={{
              backgroundImage: "url(../down-project.svg)",
              color: colors.primary,
            }}
            className={!canDisplayFilters ? "hidden" : ""}
            onChange={({ target: { value } }) => {
              setOrientacion(value);
              setExterior("");
              // setAmbientes("");
            }}
            value={orientacion}
            defaultValue=""
            required
          >
            <option disabled value="">
              {orientacionOptions?.title}
            </option>

            {orientacionOptions?.options.map((option, i) => (
              <option value={option.value} key={i}>
                {option.label}
              </option>
            ))}
          </select>
        )}

        {exteriorOptions?.options && (
          <select
            style={{
              backgroundImage: "url(../down-project.svg)",
              color: colors.primary,
            }}
            className={!canDisplayFilters ? "hidden" : ""}
            onChange={({ target: { value } }) => {
              setExterior(value);
              setOrientacion("");
              // setAmbientes("");
            }}
            value={exterior}
            defaultValue=""
            required
          >
            <option disabled value="">
              {exteriorOptions?.title}
            </option>

            {exteriorOptions?.options.map((option, i) => (
              <option value={option.value} key={i}>
                {option.label}
              </option>
            ))}
          </select>
        )}
        {filteredBy ? (
          <div className="filtered-by font-bold">
            Filtrado por:{" "}
            <span
              style={{
                color: colors.secondary,
              }}
            >
              {filteredBy}
            </span>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default ProjectSearchForm;
